/**
 * Passe la première lettre en majuscule et les autres en minuscule
 * @param {string} str 
 * @returns {string} la string formattée
 */
export const UpperFirst = str => typeof str === 'string' ? str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase() : ''

export const PropWatcher = p => <>{console.log(p)}</>
